export class Country {
  short: string;
  title: string;
  id: number;

  constructor() {
    this.id = 0;
    this.short = "";
    this.title = "";
  }
}
